import NotFound from "../../core/NotFound/NotFound";
import { LoadingSpinner } from "../../core/components/LoadingSpinner";
import { useParams } from 'react-router-dom';
import { useUserQuery } from "../api/userManagementApiHooks";
import { UserDetailsProvider } from "../UserDetailsProvider";
import "./EditUser.css";
import { EditUserForm } from "./EditUserForm";
import { jsx as _jsx } from "react/jsx-runtime";
function EditUser() {
  const params = useParams();
  const username = decodeURIComponent(params.username);
  const userQuery = useUserQuery({
    username
  });
  if (userQuery.isLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  if (userQuery.isError) {
    throw userQuery.error;
  }
  if (!userQuery.isLoading && !userQuery.data.user) {
    return /*#__PURE__*/_jsx(NotFound, {});
  }
  return /*#__PURE__*/_jsx(UserDetailsProvider, {
    user: userQuery.data.user,
    "data-sentry-element": "UserDetailsProvider",
    "data-sentry-component": "EditUser",
    "data-sentry-source-file": "EditUser.tsx",
    children: /*#__PURE__*/_jsx(EditUserForm, {
      isLoading: userQuery.isLoading,
      "data-sentry-element": "EditUserForm",
      "data-sentry-source-file": "EditUser.tsx",
      "data-sentry-element": "EditUserForm"
    })
  });
}
export default EditUser;